//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { CashCategoryDisplayItem } from './CashCategoryDisplayItem';
import { TaxDisplayItem } from './TaxDisplayItem';
import { CashAttachmentDisplayItem } from './CashAttachmentDisplayItem';
import { RepeatDetailsItem } from './RepeatDetailsItem';
import { CashType } from './Enums';

export class CashDisplayItem extends ItemBase {
    ID: string | null = null;
    SchoolID: string | null = null;
    Date: string = "1970-01-01T00:00:00";
    Amount: number = 0;
    Accrued: boolean = false;
    CategoryID: string | null = null;
    Category: CashCategoryDisplayItem | null = null;
    Description: string | null = null;
    Payee: string | null = null;
    HasAttachments: boolean = false;
    CashType: CashType = CashType.Revenue;
    HasPayroll: boolean = false;
    HasMileage: boolean = false;
    ReceivableID: string | null = null;
    Revenue: number | null = null;
    Expense: number | null = null;
    Method: string | null = null;
    Taxes: TaxDisplayItem[] = [];
    CashAttachments: CashAttachmentDisplayItem[] = [];
    Editable: boolean = false;
    RepeatDetails: RepeatDetailsItem | null = null;
    IsRemittance: boolean = false;

    constructor(initializer?: Partial<CashDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CashDisplayItem";
}
